<template>
  <div class="form-wrapper">
    <div class="form">
      <div>
        <div class="logo">
          <a href="https://easydelivery.com.br" target="_blank">
            <img src="https://cdn.easydelivery.com.br/easy_logo_pink.svg" />
          </a>
        </div>

        <div
          class="steps"
          :class="stepRegister === 5 ? 'invisible' : ''"
          v-if="stepRegister > 0"
        >
          <div class="step">
            <span
              class="circle"
              :class="{ active: stepRegister + 1 === 1 }"
            ></span>
            <span
              class="circle"
              :class="{ active: stepRegister + 1 === 2 }"
            ></span>
            <span
              class="circle"
              :class="{ active: stepRegister + 1 === 3 }"
            ></span>
            <span
              class="circle"
              :class="{ active: stepRegister + 1 === 4 }"
            ></span>
            <span
              class="circle"
              :class="{ active: stepRegister + 1 === 5 }"
            ></span>
          </div>
          <span class="step-of">{{ `${stepRegister + 1} de 5` }}</span>
        </div>

        <div class="form-container">
          <div
            class="d-flex flex-wrap w-100 justify-center"
            v-if="stepRegister === 0"
          >
            <p class="welcome animated" :class="{ 'text-center': !!isMobile }">
              Crie sua conta
            </p>
            <p class="message">Já tem uma conta?</p>
            <p @click="$router.replace({ name: 'login' })" class="sign-in">
              Entrar
            </p>
          </div>
          <div
            class="d-flex flex-wrap w-100 justify-center"
            v-else-if="stepRegister === 1"
          >
            <p class="title" :class="{ 'text-center': !!isMobile }">
              Confirme seu e-mail
            </p>
            <p class="message line-height">
              Para confirmar seu e-mail, insira o código enviado para
              <span class="email">{{ user.email }}</span> no campo abaixo:
            </p>
          </div>
          <div
            class="d-flex flex-wrap w-100 justify-center"
            v-else-if="stepRegister === 2"
          >
            <p class="title" :class="{ 'text-center': !!isMobile }">
              Link da loja
            </p>
            <p class="message">Agora vamos definir um link para a sua loja!</p>

            <div class="box_url_site">
              <p class="url_site" v-if="environmentAlias === null">
                easydelivery.com.br/<span class="name_store">pizzadamaria</span>
              </p>
              <p class="url_site" v-else>
                easydelivery.com.br/<span class="name_store">{{
                  environmentAlias
                }}</span>
              </p>
            </div>
          </div>
          <div
            class="d-flex flex-wrap w-100 justify-center"
            v-else-if="stepRegister === 3"
          >
            <p class="title" :class="{ 'text-center': !!isMobile }">
              Quase tudo concluído.
            </p>
            <p class="message" :class="isMobile ? 'mb_0' : 'mb_30'">
              Agora você só precisa definir os dados de acesso da sua loja.
            </p>
          </div>
          <div
            class="d-flex flex-wrap w-100 justify-center"
            v-else-if="stepRegister === 4"
          >
            <p class="title" :class="{ 'text-center': !!isMobile }">
              Confirme seu telefone
            </p>
            <p class="message line-height">
              Para confirmar seu telefone, insira o código enviado para o número
              <span class="phone">{{ Utils.phoneMask(user.phone) }}</span>
              no campo abaixo:
            </p>
          </div>

          <!-- <div
            class="d-flex flex-wrap w-100 justify-center"
            v-else-if="stepRegister === 5"
          >
            <p class="title" :class="{ 'text-center': !!isMobile }">
              Insira sua chave de acesso
            </p>
            <p class="message line-height">
              Para concluir seu cadastro, insira a sua chave de acesso.
            </p>
          </div> -->

          <custom-form
            v-if="stepRegister === 0"
            ref="formStep0"
            class="form-login"
          >
            <name-input design="one" v-model="user.name" class="mb_25 pt_0" />

            <div class="row half-cols">
              <div class="col-xs-6">
                <email-input
                  design="one"
                  v-model="user.email"
                  class="mb_25 pt_0"
                  :required="true"
                />
              </div>
              <div class="col-xs-6">
                <cellphone-input
                  design="one"
                  v-model="user.phone"
                  class="mb_25 pt_0"
                  :required="true"
                />
              </div>
            </div>

            <base-checkbox
              ref="checkTerms"
              v-model="acceptTerms"
              :checked="acceptTerms"
              class="mb_25"
            >
              <p class="text-checkbox">
                Eu declaro que li e concordo com os&nbsp;
                <a
                  href="https://easydelivery.com.br/politicas/termos-de-uso-restaurante"
                  target="_blank"
                  >termos de uso</a
                >
                &nbsp;e&nbsp;
                <a
                  href="https://easydelivery.com.br/politicas/privacidade"
                  target="_blank"
                  >política de privacidade.</a
                >
              </p>
            </base-checkbox>

            <base-button
              slot="footer"
              :text="'Cadastrar'"
              class="w-100 big"
              @click="jumpStep(1)"
            />
          </custom-form>

          <div v-if="stepRegister === 0">
            <div
              v-if="!isAppDesktop() && getOS() === 'Windows'"
              class="download"
            >
              <i class="fal fa-desktop" />
              <a href="https://easydelivery.com.br/downloads/" target="_blank"
                >Baixar para Windows</a
              >
            </div>

            <div
              v-if="!isAppMobile() && getOS() === 'Android'"
              class="download"
            >
              <img
                src="@/assets/img/playstore.svg"
                alt="Baixar na Play Store"
              />
              <a href="https://easydelivery.com.br/downloads/" target="_blank"
                >Baixar na Play Store</a
              >
            </div>
          </div>

          <custom-form
            v-if="stepRegister === 1"
            ref="formStep1"
            class="form-login"
          >
            <email-code
              design="one"
              label="enviado"
              v-model="emailCode"
              :blur="false"
              ref="emailCode"
            />

            <base-button
              slot="footer"
              :text="'Próximo'"
              class="w-100 big mt_25"
              @click="jumpStep(2)"
            />

            <div slot="footer" class="links">
              <p @click="jumpStep(0, 'back')">Voltar</p>
              <div class="divisor"></div>
              <p @click="$router.replace({ name: 'login' })">
                Cancelar cadastramento
              </p>
              <div class="divisor"></div>
              <p v-if="emailTimer > 0" :style="emailTimer > 0 && 'opacity: .5'">
                Reenviar código ({{ secondsToMinutesString(emailTimer) }})
              </p>
              <p v-else @click="requestEmailCode()">Reenviar código</p>
            </div>
          </custom-form>
          <custom-form
            v-if="stepRegister === 2"
            ref="formStep2"
            class="form-login"
          >
            <url-input
              design="one"
              v-model="environmentAlias"
              ref="environmentAlias"
              @keyup="startEnvironmentAliasTimer()"
              class="pt_0"
              placeholder="Ex: pizzadamaria"
            />

            <base-button
              slot="footer"
              :text="'Próximo'"
              class="w-100 big mt_25"
              @click="jumpStep(3)"
            />
            <div slot="footer" class="links">
              <p @click="$router.replace({ name: 'login' })">
                Cancelar cadastramento
              </p>
            </div>
          </custom-form>
          <custom-form
            v-if="stepRegister === 3"
            ref="formStep3"
            class="form-login"
          >
            <username-input
              design="one"
              v-model="user.username"
              ref="username"
              @keyup="startUsernameTimer()"
              class="pt_0"
            />
            <password-input
              design="one"
              v-model="user.password"
              class="mb_25 pt_0"
              label="Sua senha"
              labelConfirm="Confirmar a senha"
              ref="password"
            />

            <base-button
              slot="footer"
              :text="'Próximo'"
              :design="designButton"
              class="w-100 big"
              @click="jumpStep(4)"
            />
            <div slot="footer" class="links">
              <p @click="jumpStep(2, 'back')">Voltar</p>
              <div class="divisor"></div>
              <p @click="$router.replace({ name: 'login' })">
                Cancelar cadastramento
              </p>
            </div>
          </custom-form>

          <custom-form
            v-if="stepRegister === 4"
            ref="formStep4"
            class="form-login"
          >
            <phone-code
              design="one"
              label="via SMS"
              v-model="phoneCode"
              :blur="false"
              ref="phoneCode"
            />

            <base-button
              slot="footer"
              :text="'Finalizar'"
              :loading="loading"
              class="w-100 big mt_25"
              @click="jumpStep(5)"
            />
            <div slot="footer" class="links">
              <p @click="jumpStep(3, 'back')">Voltar</p>
              <div class="divisor"></div>
              <p @click="$router.replace({ name: 'login' })">
                Cancelar cadastramento
              </p>
              <div class="divisor"></div>
              <p v-if="phoneTimer > 0" :style="emailTimer > 0 && 'opacity: .5'">
                Reenviar código ({{ secondsToMinutesString(phoneTimer) }})
              </p>
              <p v-else @click="requestPhoneCode()">Reenviar código</p>
            </div>
          </custom-form>

          <!-- <custom-form
            v-if="stepRegister === 5"
            ref="formStep5"
            class="form-login"
          >
            <access-key-code
              design="one"
              uniqueLabel="Chave de acesso"
              v-model="accessKeyCode"
              ref="accessKeyCode"
              accessKey
            />

            <base-button
              slot="footer"
              :text="'Concluir cadastro'"
              class="w-100 big mt_25"
              @click="jumpStep(6)"
            />

            <div slot="footer" class="links">
              <p @click="$router.replace({ name: 'login' })">
                Cancelar cadastramento
              </p>
            </div>
          </custom-form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import '@/assets/css/veasy/login.css';
import getOS from '@/mixins/getOS.js';

import { setXUserKey, setXAPIEnv, getXUserKey } from '@/plugins/account';
import AppBridge from '@/plugins/app';
import DesktopBridge from '@/plugins/desktop';
import Utils from '@/utils';

// UI
import BaseInput from '@/components/Input';
import BaseBox from '@/components/Box';
import BaseCheckbox from '@/components/Checkbox';
import BaseLogo from '@/components/Logo';
import BaseButton from '@/components/Button';
import BaseMessage from '@/components/Message';
import CustomForm from '@/containers/Form.vue';
import EmailInput from '@/containers/Inputs/EmailInput';
import NameInput from '@/containers/Inputs/NameInput';
import CellphoneInput from '@/containers/Inputs/CellphoneInput';
import UsernameInput from '@/containers/Inputs/UsernameInput';
import UrlInput from '@/containers/Inputs/StoreAliasInput';
import PasswordInput from '@/containers/Inputs/DoublePwInput';
import EmailCode from '@/containers/Inputs/ConfirmCodeInput';
import PhoneCode from '@/containers/Inputs/ConfirmCodeInput';
import AccessKeyCode from '@/containers/Inputs/ConfirmCodeInput';

import User from 'easyjs/lib/Schema/Account/User';
import AccountAPI from '@/api/account';
import StoreAPI from '@/api/store';
import { Http } from 'easyjs';
import { mapState } from 'vuex';

const { Request } = Http;
export default {
  mixins: [getOS],
  data() {
    return {
      Utils,
      user: new User({ phone: '', password: {} }),
      acceptTerms: false,
      emailCode: null,
      emailTimer: 0,
      phoneCode: null,
      accessKeyCode: null,
      phoneTimer: 0,
      environmentAlias: null,
      environmentTimerId: null,
      usernameTimerId: null,
      designButton: 'one',
      stepRegister: 0,
      loading: false,
      messageSend: false,
    };
  },
  components: {
    BaseInput,
    BaseBox,
    BaseLogo,
    BaseCheckbox,
    BaseButton,
    BaseMessage,
    CustomForm,
    EmailInput,
    NameInput,
    CellphoneInput,
    UsernameInput,
    UrlInput,
    PasswordInput,
    EmailCode,
    PhoneCode,
    AccessKeyCode,
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  watch: {
    acceptTerms() {
      this.removeFormErrorValidation('formStep0', 'checkTerms');
    },
  },
  mounted() {
    this.$refs.username.focus();
  },
  methods: {
    async whatsApp() {
      const data = {
        cmd: 'chat',
        id: 'xpto',
        to: `55${this.user.phone}@c.us`,
        msg: `
          Olá, ${this.user.name}!\n\nEu sou a Ana e vim te dar as boas vindas ao Easy Delivery!\n\nQuero apenas avisar que estou à disposição para te ajudar enquanto estamos em fase beta.\n\nPor isso, nesse período conte comigo pra tirar dúvidas, reportar erros ou mandar elogios por aqui das 10h às 18h, de segunda a sexta-feira.\n\nE se quiser conhecer mais sobre a gente, segue nosso Insta:\n\ninstagram.com/easydelivery.tech\n\nAbraço!
        `,
      };

      const options = {
        method: 'POST',
        url: 'https://v1.utalk.chat/send/9ph7qfu/',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(data),
      };

      if (!this.messageSend) {
        this.messageSend = true;

        await axios.request(options);
      }
    },
    isAppDesktop() {
      return DesktopBridge.isDesktop();
    },
    isAppMobile() {
      return AppBridge.isApp();
    },
    secondsToMinutesString(seconds) {
      const finalMinutes = (seconds - (seconds % 60)) / 60;
      const finalSeconds = seconds % 60;
      return `${`${finalMinutes}`.padStart(
        2,
        '0'
      )}:${`${finalSeconds}`.padStart(2, '0')}`;
    },
    setFormErrorValidation(form, input, codeMessage) {
      this.$refs[form].setErrorValidation(
        this.$refs[input].inputId,
        codeMessage
      );
      this.$refs[input].isValid = false;
    },
    removeFormErrorValidation(form, input) {
      this.$refs[form].removeErrorValidation(this.$refs[input].inputId);
      this.$refs[input].isValid = true;
    },
    async validateUsername() {
      const user = this.user;
      if (!this.usernameTimerId) {
        const responseAccount = await AccountAPI.isAccount(user.username);
        if (!!responseAccount.getData({ is_account: true }).is_account) {
          this.setFormErrorValidation('formStep3', 'username', '6006');
          return false;
        }
      }
      this.removeFormErrorValidation('formStep3', 'username');
      return true;
    },
    async validateEnvironmentAlias() {
      try {
        const response = await StoreAPI.isEnvironment(this.environmentAlias);
        if (!!response.getData({ is_environment: true }).is_environment) {
          this.setFormErrorValidation('formStep2', 'environmentAlias', '7004');
          return false;
        }
        this.removeFormErrorValidation('formStep2', 'environmentAlias');
        return true;
      } catch (err) {
        this.setFormErrorValidation('formStep2', 'environmentAlias', '7005');
        return false;
      }
    },
    async validateEmailCode() {
      const response = await AccountAPI.validateEmailCode(
        this.emailCode,
        this.user.email
      );
      if (!response.getData({ success: false }).success) {
        this.emailCode = null;
        this.setFormErrorValidation('formStep1', 'emailCode', '8000');
        return false;
      }
      return true;
    },
    async validatePhoneCode() {
      const response = await AccountAPI.validatePhoneCode(
        this.phoneCode,
        this.user.phone
      );
      if (!response.getData({ success: false }).success) {
        this.phoneCode = null;
        this.setFormErrorValidation('formStep4', 'phoneCode', '8000');
        return false;
      }
      return true;
    },
    async validateAccessfKeyCode() {
      const response = await AccountAPI.validateAccessKeyCode(
        this.accessKeyCode
      );
      if (!response.getData({ valid: false }).valid) {
        this.setFormErrorValidation('formStep5', 'accessKeyCode', '8003');
        return false;
      }
      return true;
    },
    async jumpStep(step, back) {
      if (document.querySelector('.mode-info.red') != null) {
        const element = document.querySelector('.mode-info.red');
        element.textContent = '';
      }

      if (back) {
        if (this.stepRegister === 1) {
          this.$refs.emailCode.$refs.baseinput.focus();
        } else if (this.stepRegister === 3) {
          this.removeFormErrorValidation('formStep3', 'username');
        } else if (this.stepRegister === 4) {
          this.$refs.phoneCode.$refs.baseinput.focus();
        }
        return (this.stepRegister = step);
      }

      switch (step) {
        case 0:
          this.stepRegister = step;
          break;
        case 1: // Validar usuário
          if (this.$refs.formStep0.validateInputs()) {
            this.messageSend = false;

            if (this.acceptTerms) {
              // Registra novo usuário como lead no sistema
              const { name, email, phone } = this.user;
              await StoreAPI.addLead(name, email, phone);

              this.requestEmailCode();
              // this.whatsApp();
              this.stepRegister = step;
            } else {
              this.setFormErrorValidation('formStep0', 'checkTerms', '10000');
            }
          }
          break;
        case 2:
          if (
            this.$refs.formStep1.validateInputs() &&
            (await this.validateEmailCode())
          ) {
            this.stepRegister = step;
          }
          break;
        case 3:
          if (
            this.$refs.formStep2.validateInputs() &&
            (await this.validateEnvironmentAlias())
          ) {
            if (document.querySelector('.mode-info.red') != null) {
              const element = document.querySelector('.mode-info.red');
              element.textContent = '';
            }
            this.stepRegister = step;
          }
          break;
        case 4:
          if (
            this.$refs.formStep3.validateInputs() &&
            (await this.validateUsername())
          ) {
            this.requestPhoneCode();
            this.stepRegister = step;
          }
          break;
        case 5:
          if (
            this.$refs.formStep4.validateInputs() &&
            (await this.validatePhoneCode())
          ) {
            this.loading = true;
            await this.registerEnvironment();
          }
          break;
        default:
          break;
      }
    },
    async requestEmailCode() {
      this.emailCode = null;

      const response = await AccountAPI.requestEmailCode(this.user.email);
      if (!response.getData({ success: false }).success) {
        this.setFormErrorValidation('formStep1', 'emailCode', '8002');
        return false;
      }

      this.$refs.emailCode.$refs.baseinput.focus();

      this.emailTimer = 60;
      const timerId = setInterval(() => {
        if (this.emailTimer > 0) {
          this.emailTimer--;
        } else {
          clearInterval(timerId);
        }
      }, 1000);

      return true;
    },
    async requestPhoneCode() {
      this.phoneCode = null;

      const response = await AccountAPI.requestPhoneCode(this.user.phone);
      if (!response.getData({ success: false }).success) {
        this.setFormErrorValidation('formStep4', 'phoneCode', '8002');
        return false;
      }

      this.phoneTimer = 60;
      const timerId = setInterval(() => {
        if (this.phoneTimer > 0) {
          this.phoneTimer--;
        } else {
          clearInterval(timerId);
        }
      }, 1000);
      return true;
    },
    startUsernameTimer() {
      const user = this.user;
      this.usernameError = null;

      // Limpa o timer anterior
      if (this.usernameTimerId) {
        clearTimeout(this.usernameTimerId);
        this.usernameTimerId = null;
      }

      // Não permite alias com com menos de 5 letras
      if (this.user.username.length < 5) {
        return;
      }

      this.usernameTimerId = setTimeout(async () => {
        this.usernameTimerId = null;
        await this.validateUsername();
      }, 1000);
    },
    startEnvironmentAliasTimer() {
      // Limpa o timer anterior
      if (this.environmentTimerId) {
        clearTimeout(this.environmentTimerId);
        this.environmentTimerId = null;
      }

      // Não permite alias com com menos de 5 letras
      if (this.environmentAlias.length < 5) {
        return;
      }

      this.environmentTimerId = setTimeout(async () => {
        await this.validateEnvironmentAlias();

        this.$refs.environmentAlias.$refs.baseinput.focus();

        this.environmentTimerId = null;
      }, 1000);
    },
    async registerEnvironment() {
      try {
        this.designButton = 'two';
        const response = await Request.post({
          service: 'store',
          endpoint: '/environment',
          data: {
            alias: this.environmentAlias,
            user: {
              username: this.user.username,
              name: this.user.name,
              password: this.user.password,
              email: this.user.email,
              phone: this.user.phone,
            },
            // accessTokenCode: this.accessKeyCode,
          },
        });

        const environmentData = response.getData({ environment_id: null });
        if (environmentData.environment_id) {
          setXAPIEnv(this.environmentAlias);
          setXUserKey(environmentData.login_hash);
          const config = await this.$store.dispatch('store/getConfigurations');

          fetch(
            `${process.env.VUE_APP_API}/sitemap/indexer/${environmentData.environment_id}`
          )
            .then((response) => response.json())
            .then((data) => {
              if (!data.success) {
                console.error('Erro ao indexar site');
              }
            });

          if (DesktopBridge.isDesktop()) {
            DesktopBridge.emit('onLoginUpdate');
          }

          if (window.fbq) {
            window.fbq('init', '760209684593391');
            window.fbq('track', 'Lead');
          }

          window.gtag('event', 'conversion', {
            send_to: 'AW-308325207/jlB7CLu9vqADENfWgpMB',
          });

          this.$router.push({ name: 'sucesso-cadastro' });
        } else {
          this.designButton = 'one';
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
